import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Modal } from '@unimed-fesp/components';

// #region Assets
import { ReactComponent as Upload } from '../../../assets/icons/upload.svg';
// #endregion

import { legacyRoutes } from '../../../routes/legacyRoutes';

import Card from '../../molecules/Card';
import { ModalContentWrapper } from '../../molecules/Modal';

import theme from '../../../styles/theme';
import { Container, ContentText } from './styles';

function ModalInclusaoUspLista({ isOpen, onClick, handleClick }) {
  const { usuario } = useSelector((state) => state.auth);
  const lista = useSelector((state) => state.lista);
  const dispatch = useDispatch();

  return (
    <Modal
      width={800}
      height={350}
      isOpen={isOpen}
      onClick={onClick}
      header={<>Inclusão</>}
    >
      <ModalContentWrapper>
        <ContentText>
          Selecione entre <strong>Titular</strong> ou <strong>Dependente</strong>
        </ContentText>
        <Container>
          <a
            href={legacyRoutes.CadastrarListaTitularUSP.url}
            style={{
              textDecoration: 'none',
            }}
          >
            <Card text="titular">
              <Upload fill={theme.grayDefault} />
            </Card>
          </a>
          <a
            href={legacyRoutes.CadastrarListaDependenteUSP.url}
            style={{
              textDecoration: 'none',
            }}
          >
            <Card text="dependente">
              <Upload fill={theme.grayDefault} />
            </Card>
          </a>
        </Container>
      </ModalContentWrapper>
    </Modal>
  );
}

export default ModalInclusaoUspLista;
